import includeContent from '../../assets/include-content.png';
import { FEATURES, NOTICES } from '../Documents/const';
import gentleTip from '../../assets/gentle-tip.png';

// 描述卡片
const DescCards = () => {
    return (
        <div
            className={'mb-12 mt-8 flex w-full flex-col justify-between gap-4 text-sm md:flex-row'}
        >
            {/*左侧描述list*/}
            <div className={'flex-1 rounded-xl bg-white bg-opacity-50 p-4'}>
                <div className={'flex justify-start'}>
                    <img className={'mb-4 h-[26px] w-[100px]'} src={includeContent} alt="" />
                </div>
                <div className={'flex w-full flex-col justify-between md:flex-row'}>
                    <div className={'flex w-48 flex-col gap-4'}>
                        {FEATURES.left.map((it) => {
                            return (
                                <div key={it} className={'flex items-center justify-start gap-2'}>
                                    <div className={'h-1.5 w-1.5 rounded-full bg-primary'} />
                                    <span className={'text-xs text-[#414C6F]'}>{it}</span>
                                </div>
                            );
                        })}
                    </div>
                    <div className={'mt-4 flex flex-col gap-4 md:mt-0'}>
                        {FEATURES.right.map((it) => {
                            return (
                                <div key={it} className={'flex items-center gap-2'}>
                                    <div className={'h-1.5 w-1.5 rounded-full bg-primary'} />
                                    <span className={'text-xs text-[#414C6F]'}>{it}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            {/*右侧描述list*/}
            <div className={'flex-1 rounded-xl bg-white bg-opacity-50 p-4'}>
                <div className={'flex justify-start'}>
                    <img className={'mb-4 h-[26px] w-[100px]'} src={gentleTip} alt="" />
                </div>
                <div className={'flex flex-col items-start gap-4'}>
                    {NOTICES.map((it) => {
                        return (
                            <div key={it} className={'flex items-center gap-2'}>
                                <div className={'h-1.5 w-1.5 rounded-full bg-primary'} />
                                <span className={'text-xs text-[#414C6F]'}>{it}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default DescCards;
